<template>
  <div class="drag-hint">
    <transition appear name="svg" @after-enter="onAfterEnter">
    <svg
      v-if="svgShown"
      version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="89.279px" height="375.6px" viewBox="0 0 89.279 375.6" enable-background="new 0 0 89.279 375.6" xml:space="preserve">
    <defs>
      <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="8.647" y="11.67" width="70" height="356.213">
        <feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
      </filter>
    </defs>
    <mask maskUnits="userSpaceOnUse" x="8.647" y="11.67" width="70" height="356.213" id="back_1_">
      <g filter="url(#Adobe_OpacityMaskFilter)">
        <linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="-674.5176" y1="685.834" x2="-673.5178" y2="685.834" gradientTransform="matrix(0 357.2132 357.2132 0 -245376.5156 240958.0938)">
          <stop  offset="0" style="stop-color:#cdcdcd"/>
          <stop  offset="1" style="stop-color:#cdcdcd"/>
        </linearGradient>
        <rect x="-1107.61" y="-278.746" fill="url(#SVGID_5_)" width="1440" height="1000"/>
      </g>
    </mask>
    <linearGradient id="back_2_" gradientUnits="userSpaceOnUse" x1="-674.5176" y1="687.043" x2="-673.5181" y2="687.043" gradientTransform="matrix(2.187300e-014 357.213 357.213 -2.187300e-014 -245376.4844 240957.8438)">
      <stop  offset="0" style="stop-color:#cdcdcd"/>
      <stop  offset="1" style="stop-color:#f9f8f7"/>
    </linearGradient>
    <path id="back" mask="url(#back_1_)" fill="url(#back_2_)" d="M8.647,332.883V46.67c0-19.33,15.669-35,35-35
      c19.329,0,35,15.67,35,35v286.213c0,19.33-15.671,35-35,35C24.316,367.883,8.647,352.213,8.647,332.883"/>
    <g id="ring2" :class="{'up': direction === 'up', 'down': direction === 'down'}" class="ring2" opacity="0.4">
      <g>
        <defs>
          <rect id="SVGID_6_" x="10.569" y="13.591" width="66.16" height="66.158"/>
        </defs>
        <clipPath id="SVGID_7_">
          <use xlink:href="#SVGID_6_"  overflow="visible"/>
        </clipPath>
        <path clip-path="url(#SVGID_7_)" fill="#FFFFFF" d="M76.727,46.67c0,18.269-14.811,33.079-33.079,33.079
          c-18.27,0-33.079-14.81-33.079-33.079s14.81-33.079,33.079-33.079C61.916,13.591,76.727,28.401,76.727,46.67"/>
      </g>
    </g>
    <circle id="ring" :class="{'up': direction === 'up', 'down': direction === 'down'}" class="ring" fill="none" stroke="#FFFFFF" stroke-width="5" stroke-miterlimit="10" cx="43.647" cy="46.67" r="33.079"/>
    </svg>
    </transition>
  </div>
</template>

<script>
import delay from 'lodash/delay'

export default {
  name: 'DragHint',
  data: function () {
    return {
      svgShown: true
    }
  },
  methods: {
    onAfterEnter: function () {
      console.log('after enter')
      this.svgShown = false
      delay(() => {
        console.log('restart')
        this.svgShown = true
      }, 3000)
    }
  },
  props: {
    direction: {
      required: false,
      type: String,
      default: 'up'
    }
  }
}
</script>

<style scoped lang="scss">
@import 'variables';

.drag-hint {
  pointer-events: none;
  width: 100%;
  height: 70%;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
}

svg {
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.svg-enter-active {
  transition: opacity 0.5s, transform 4s;
  .ring,
  .ring2 {
    &.up {
      animation: down-up-anim 2s $ease-in-out-quint 0s 2 normal forwards;
    }
    &.down {
      animation: down-up-anim 2s $ease-in-out-quint 0s 2 reverse forwards;
    }
  }
}
.svg-leave-active {
  transition: opacity 0.5s;
}

.svg-enter,
.svg-leave-to {
  opacity: 0;
}


@keyframes down-up-anim {
  0% {
    transform: translate(0, 284px);
  }
  100% {
    transform: translate(0, 0);
  }
}

</style>



// WEBPACK FOOTER //
// src/atoms/MobileDragHint.vue